import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42815fdc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42815fdc')) {
      api.createRecord('42815fdc', component.options)
    } else {
      api.reload('42815fdc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42815fdc&", function () {
      api.rerender('42815fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personalCenter/index.vue"
export default component.exports